import styled from 'styled-components'

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.7rem;
  line-height: 2.4rem;
  width: 100%;
  margin-top: 15px;
`;

export const TopListItem = styled(ListItem)`
  justify-content: flex-start;
`;

export const Label = styled.div`
  padding-right: 8px;
`;

export const Spacer = styled.div`
  flex: 1;
  background-image: linear-gradient(to right, white 33%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 10px 8px;
  background-repeat: repeat-x;
  height: 3px;
`;

export const Value = styled.div`
  text-align: right;
  padding-left: 5px;
`;